module.exports = __webpack_public_path__ + "img/DealerIcons-Marine-Off.eb9f2c5.jpg";